import { render, staticRenderFns } from "./DeleteDocumentDialog.vue?vue&type=template&id=4d978312&scoped=true"
import script from "./DeleteDocumentDialog.vue?vue&type=script&lang=js"
export * from "./DeleteDocumentDialog.vue?vue&type=script&lang=js"
import style0 from "./DeleteDocumentDialog.vue?vue&type=style&index=0&id=4d978312&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d978312",
  null
  
)

export default component.exports